import React, { useRef, useEffect } from 'react';
import { useGameStore } from '@store/gameStore';
import styles from './MoveHistory.module.css';

export const MoveHistory: React.FC = () => {
  const gameState = useGameStore((state) => state.gameState);
  const scrollRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    // Auto-scroll to bottom when new moves are added
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [gameState?.moveHistory]);
  
  if (!gameState) return null;
  
  const movePairs: Array<[any, any | null]> = [];
  for (let i = 0; i < gameState.moveHistory.length; i += 2) {
    movePairs.push([
      gameState.moveHistory[i],
      gameState.moveHistory[i + 1] || null
    ]);
  }
  
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Move History</h3>
      <div className={styles.moves} ref={scrollRef}>
        {movePairs.length === 0 ? (
          <p className={styles.empty}>No moves yet</p>
        ) : (
          movePairs.map(([whiteMove, blackMove], index) => (
            <div key={index} className={styles.movePair}>
              <span className={styles.moveNumber}>{index + 1}.</span>
              <span className={styles.move}>{whiteMove.notation.san}</span>
              {blackMove && (
                <span className={styles.move}>{blackMove.notation.san}</span>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};